var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.list),function(item,index){return _c('div',{staticStyle:{"color":"#fff"},on:{"click":function($event){return _vm.get_list(index)}}},[_vm._v(_vm._s(item))])}),_c('div',[_vm._v(_vm._s(_vm.li))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }